import { tap, compose } from 'ramda';
import { SlugsByUUID } from './entities';
import { addSlugs } from './store'

const saveSlugsFromRels = tap(
  compose(
    addSlugs,
    SlugsByUUID,
  )
)

export { saveSlugsFromRels };
